import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿En qué formato recibo el material?',
    a: 'PDF descargable. Acceso inmediato después del pago. Podés imprimirlo o usarlo en pantalla desde el celular, tablet o computadora.'
  }, {
    q: '¿Necesito experiencia previa en autismo para usar este kit?',
    a: 'No. Cada ficha tiene instrucciones claras para el adulto escritas en lenguaje simple. No necesitás ser docente ni terapeuta. Si acompañás a un niño con autismo y querés ayudarlo a aprender a leer y escribir, este kit es para vos.'
  }, {
    q: '¿Para qué edad está pensado?',
    a: 'El material está organizado por niveles de habilidad, no por edad. Sirve para niños de nivel inicial y primario independientemente de cuántos años tienen. Si el niño no agarra el lápiz todavía, empezás por el Tomo 4. Si ya reconoce algunas letras, empezás por el Tomo 2. El Checklist Ruta de Progreso (Bono #5) te dice exactamente por dónde empezar.'
  }, {
    q: '¿Funciona para niños con distintos niveles dentro del espectro?',
    a: 'Sí. El sistema está diseñado para adaptarse al punto de partida de cada niño. No hay un solo camino. Hay una escalera con 150 peldaños y vos empezás donde tu hijo está parado hoy.'
  }, {
    q: '¿Necesito materiales especiales para las fichas?',
    a: 'No. Todo lo que necesitás es un lápiz negro y a veces crayones básicos de colores. Nada más. Las fichas están diseñadas específicamente para que el niño pueda trabajar sin necesitar ningún material adicional.'
  }, {
    q: '¿Sirve tanto para casa como para el aula?',
    a: 'Sí. Es el único sistema diseñado específicamente para que el código visual sea el mismo en los dos contextos. La maestra y la mamá usan los mismos pictogramas, las mismas palabras y la misma progresión. Sin cortocircuitos.'
  }, {
    q: '¿Y si no sé por dónde empezar o me trabo en el camino?',
    a: 'El Bono #7 (Implementación Express) te da el plan de los primeros 7 días paso a paso. Y el Bono #5 (Checklist Ruta de Progreso) te dice exactamente cuándo avanzar y cuándo repetir. No te quedás sola en el proceso.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 bg-white" data-id="element-38">
      <div className="max-w-3xl mx-auto" data-id="element-39">
        <h2 className="text-3xl md:text-4xl font-black text-center text-[#111111] mb-12" data-id="element-40">
          PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-41">
          {faqs.map((faq, idx) => <div key={idx} className="border border-gray-200 rounded-2xl overflow-hidden bg-gray-50" data-id="element-42">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" aria-expanded={openIndex === idx} data-id="element-43">
                <span className="font-bold text-[#111111] text-lg pr-4" data-id="element-44">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-6 h-6 text-[#C4A7E7] flex-shrink-0 transition-transform duration-300 ${openIndex === idx ? 'rotate-180' : ''}`} data-id="element-45" />
              </button>

              <AnimatePresence data-id="element-46">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-47">
                    <div className="px-6 pb-5 text-gray-700 leading-relaxed border-t border-gray-100 pt-4" data-id="element-48">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}